// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineStackPropsSchema = z.strictObject({
	gap: mantineSpacingSchema.optional(),
	p: mantineSpacingSchema.optional(),
	align: z.string().optional(),
	justify: z.string().optional(),
});
